import { render } from "./AddScale.vue?vue&type=template&id=c88d48b2&scoped=true&bindings={\"submit\":\"options\",\"addOption\":\"options\",\"deleteOption\":\"options\",\"lastId\":\"data\",\"options\":\"data\"}"
import script from "./AddScale.vue?vue&type=script&lang=js"
export * from "./AddScale.vue?vue&type=script&lang=js"

import "./AddScale.vue?vue&type=style&index=0&id=c88d48b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c88d48b2"

export default script